import React, { Component } from 'react';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export class Footer extends Component {

  render() {
    const loc = cookies.get('locale')

    return (
      <div className='footer'>
        <div className="social">
          <a href={this.twitterUrl(loc)} target="_blank" aria-label="">
            <i class="fab fa-twitter-square fa-3x" />
          </a>

          <a href={this.facebookUrl(loc)} target="_blank" aria-label="">
            <i class="fab fa-facebook-square fa-3x"></i>
          </a>
        </div>
        <div className='copyright'>
          <h6>© Copyright node-node-node 2018</h6>
        </div>
      </div>
    )
  }

  twitterUrl = locale => {
    switch (locale) {
      case 'en': return("https://twitter.com/intent/tweet/?text=node-node-node%20%23node_node_node%20%23node_node_node_EN%20pic.twitter.com%2Fo7A7aCGNxl&amp;url=https%3A%2F%2Fnode-node-node.netlify.com%2F")
      case 'ja': return("https://twitter.com/intent/tweet/?text=node-node-node%E3%81%AE%E3%83%8E%E3%83%BC%E3%83%89%E3%80%82%20%20%23node_node_node%20%23node_node_node_JP%20pic.twitter.com%2FDwM7KGVnfa&amp;url=https%3A%2F%2Fnode-node-node.netlify.com%2F")
      default: return("https://twitter.com/intent/tweet/?text=node-node-node%20%23node_node_node%20%23node_node_node_EN%20pic.twitter.com%2Fo7A7aCGNxl&amp;url=https%3A%2F%2Fnode-node-node.netlify.com%2F")
    }
  }

  facebookUrl = locale => {
    switch (locale) {
      case 'en': return("https://facebook.com/sharer/sharer.php?u=https%3A%2F%2Fnode-node-node.netlify.com%2F")
      case 'ja': return("https://facebook.com/sharer/sharer.php?u=https%3A%2F%2Fnode-node-node.netlify.com%2F")
      default: return("https://facebook.com/sharer/sharer.php?u=https%3A%2F%2Fnode-node-node.netlify.com%2F")
    }
  }
}

const mapStateToProps = state => ({
  client: state.client,
  server: state.server
});

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(Footer)



// WEBPACK FOOTER //
// ./src/components/fixedComponents/Footer.js